import { useTranslation } from "react-i18next";
import { NeuCard, NeuSelect } from "../../components/neu/Neu";
import { DateInput } from "../../components/neu/DateInput";

const STATUSES = ["pending", "approved", "paid", "cancelled"];

// شريط الفلاتر المشترك أعلى صفحة المكافآت.
export const BonusFilters = ({ filters, setFilters, employees, branches }) => {
  const { t } = useTranslation();
  const set = (key) => (e) => setFilters({ ...filters, [key]: e.target.value });

  return (
    <NeuCard className="grid gap-3 p-4 sm:grid-cols-2 lg:grid-cols-6" data-testid="bonus-filters">
      <label className="grid gap-1 text-xs font-bold">
        {t("bonus.filters.employee")}
        <NeuSelect data-testid="bonus-filter-employee" value={filters.user_id} onChange={set("user_id")}>
          <option value="">{t("bonus.filters.all")}</option>
          {employees.map((e) => (
            <option key={e.id} value={e.id}>{e.name}</option>
          ))}
        </NeuSelect>
      </label>
      <label className="grid gap-1 text-xs font-bold">
        {t("bonus.filters.branch")}
        <NeuSelect data-testid="bonus-filter-branch" value={filters.branch_id} onChange={set("branch_id")}>
          <option value="">{t("bonus.filters.all")}</option>
          {branches.map((b) => (
            <option key={b.id} value={b.id}>{b.name}</option>
          ))}
        </NeuSelect>
      </label>
      <label className="grid gap-1 text-xs font-bold">
        {t("bonus.filters.status")}
        <NeuSelect data-testid="bonus-filter-status" value={filters.status} onChange={set("status")}>
          <option value="">{t("bonus.filters.all")}</option>
          {STATUSES.map((key) => (
            <option key={key} value={key}>{t(`bonus.status.${key}`)}</option>
          ))}
        </NeuSelect>
      </label>
      <label className="grid gap-1 text-xs font-bold">
        {t("bonus.filters.month")}
        <NeuSelect data-testid="bonus-filter-month" value={filters.month} onChange={set("month")}>
          <option value="">{t("bonus.filters.all")}</option>
          {Array.from({ length: 12 }, (_, i) => i + 1).map((m) => (
            <option key={m} value={m}>{m}</option>
          ))}
        </NeuSelect>
      </label>
      <label className="grid gap-1 text-xs font-bold">
        {t("bonus.filters.receipt")}
        <NeuSelect data-testid="bonus-filter-receipt" value={filters.confirmation_status}
                   onChange={set("confirmation_status")}>
          <option value="">{t("bonus.filters.all")}</option>
          <option value="confirmed">{t("bonus.receivedPill")}</option>
          <option value="rejected_by_employee">{t("bonus.rejectedPill")}</option>
        </NeuSelect>
      </label>
      <label className="grid gap-1 text-xs font-bold">
        {t("bonus.filters.from")}
        <DateInput data-testid="bonus-filter-from" value={filters.from_date} onChange={set("from_date")} />
      </label>
      <label className="grid gap-1 text-xs font-bold">
        {t("bonus.filters.to")}
        <DateInput data-testid="bonus-filter-to" value={filters.to_date} onChange={set("to_date")} />
      </label>
    </NeuCard>
  );
};
